<template>
  <div class="container step">
    <div class="head-top">
      <img src="../../assets/step4/page4_head.png" alt="">
      <div class="text">
        針對第一線不適合Cisplatin療法 ECOG PS=0的病患,在接受TECENTRIQ治療後<br/>
        <span class="caption">mOS</span> 達 <span class="caption">25</span>個月
        <h5 style="color:#b6798e;margin:0;">
          (IMvigor 210 Phase II, n=119)
        </h5>
        <div class="flow-text">
            IMvigor 210 Phase II, multicenter, open-label, 2-cohort trial design in locally advanced or metastatic urothelial carcinoma (n=119)
        </div>
      </div>
    </div><!-- Top end sub-->
    <div class="flow-container">
      <a href="#" @click.prevent="selectFlow.flow1 = !selectFlow.flow1" style="width:90%;">
        <img v-if="selectFlow.flow1 === false" src="../../assets/step4/page4_flow.png" alt="">
        <img v-if="selectFlow.flow1" src="../../assets/step4/page4_flow_change.png" alt="">
      </a>
    </div>
    <template>
      <router-link to="/step4-1" class="btn-prev el-icon-arrow-left"></router-link>
      <router-link to="/step5-1" class="btn-next el-icon-arrow-right"></router-link>
    </template>
  </div>
</template>

<script>
export default {
  name: 'step1-2',
  props: ['result'],
  mounted: function () {
    console.log(this.result)
  },
  data () {
    return {
      pageChage: false,
      selectFlow: {
        flow1: false,
        flow2: false
      }
    }
  }
}
</script>

<style scoped>
  a[class*="btn-"] {
    background:#b7798e;color:white;
  }
  .flow-text {
    color:#5f5f5f;font-size:12px;
    text-align:left;display:block;
    line-height:16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/step4/flow.vue